import { IconProps } from "../../../types/style";

const GetLoadIcon = (prop: IconProps) => {
  const { color = "#f5f5f5", size = 24 } = prop;
  return (
    <div style={{ height: size + "px" }}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 25 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M17.85 5.31003L12.2 2.27003C11.6 1.95003 10.89 1.95003 10.29 2.27003L4.64998 5.31003C4.23998 5.54003 3.97998 5.98003 3.97998 6.46003C3.97998 6.95003 4.22998 7.39003 4.64998 7.61003L10.3 10.65C10.6 10.81 10.93 10.89 11.25 10.89C11.57 10.89 11.91 10.81 12.2 10.65L17.85 7.61003C18.26 7.39003 18.52 6.95003 18.52 6.46003C18.52 5.98003 18.26 5.54003 17.85 5.31003Z"
          fill={color}
        />
        <path
          d="M9.37 11.7101L4.12 9.09009C3.71 8.88009 3.25 8.91009 2.86 9.14009C2.48 9.38009 2.25 9.79009 2.25 10.2401V15.2001C2.25 16.0601 2.73 16.8301 3.5 17.2201L8.75 19.8401C8.93 19.9301 9.13 19.9801 9.33 19.9801C9.56 19.9801 9.8 19.9101 10.01 19.7901C10.39 19.5501 10.62 19.1401 10.62 18.6901V13.7301C10.61 12.8701 10.13 12.1001 9.37 11.7101Z"
          fill={color}
        />
        <path
          d="M20.25 10.2401V12.7001C19.77 12.5601 19.26 12.5001 18.75 12.5001C17.39 12.5001 16.06 12.9701 15.01 13.8101C13.57 14.9401 12.75 16.6501 12.75 18.5001C12.75 18.9901 12.81 19.4801 12.94 19.9501C12.79 19.9301 12.64 19.8701 12.5 19.7801C12.12 19.5501 11.89 19.1401 11.89 18.6901V13.7301C11.89 12.8701 12.37 12.1001 13.13 11.7101L18.38 9.09009C18.79 8.88009 19.25 8.91009 19.64 9.14009C20.02 9.38009 20.25 9.79009 20.25 10.2401Z"
          fill={color}
        />
        <path
          d="M22.25 15.7C22.25 15.69 22.24 15.68 22.23 15.67C22.19 15.61 22.14 15.55 22.09 15.5C22.08 15.49 22.07 15.47 22.06 15.46C21.25 14.56 20.06 14 18.75 14C17.49 14 16.34 14.52 15.52 15.36C14.73 16.17 14.25 17.28 14.25 18.5C14.25 19.34 14.49 20.14 14.9 20.82C15.12 21.19 15.4 21.53 15.72 21.81C15.74 21.82 15.75 21.83 15.76 21.84C15.81 21.89 15.86 21.93 15.92 21.98C15.92 21.98 15.92 21.98 15.93 21.98C15.94 21.99 15.95 22 15.96 22C16.71 22.63 17.68 23 18.75 23C20.39 23 21.82 22.12 22.6 20.82C22.83 20.43 23.01 20 23.12 19.55C23.21 19.21 23.25 18.86 23.25 18.5C23.25 17.44 22.88 16.46 22.25 15.7ZM20.43 19.23H19.5V20.2C19.5 20.61 19.16 20.95 18.75 20.95C18.34 20.95 18 20.61 18 20.2V19.23H17.07C16.66 19.23 16.32 18.89 16.32 18.48C16.32 18.07 16.66 17.73 17.07 17.73H18V16.84C18 16.43 18.34 16.09 18.75 16.09C19.16 16.09 19.5 16.43 19.5 16.84V17.73H20.43C20.84 17.73 21.18 18.07 21.18 18.48C21.18 18.89 20.85 19.23 20.43 19.23Z"
          fill={color}
        />
      </svg>
    </div>
  );
};

export default GetLoadIcon;
